export default function SortLibrary({ setSortState, t }) {
    return (
        <div className="col-4 col-md-2 px-2">
            <select id="sortBooks" className="form-select form-select-sm"
                onChange={e => setSortState(e.target.value)}>
                <option value="sortNone">{t("SortName")}</option>
                <option value="priceAscending">{t("SortPriceLH")}</option>
                <option value="priceDescending">{t("SortPriceHL")}</option>
            </select>
        </div>
    )
}